<div class="form-group">
  <label for="unfreezeDateInput">Unfreeze Date</label>

  <app-date-picker [id]="'unfreezeDateInput'"
                   [(content)]="unfreezeDate"
                   (contentChange)="updateUnfreezeDaysFromNow()"></app-date-picker>
</div>

<div class="alert alert-warning" *ngIf="unfreezeDaysFromNow && (unfreezeDaysFromNow > 30)">
  Your chosen unfreeze date is {{ unfreezeDaysFromNow }} days in the future. Please double check that this is correct before submitting.
</div>
<div class="alert alert-danger" *ngIf="unfreezeDaysFromNow && (unfreezeDaysFromNow <= 0)">
  The unfreeze date must be in the future. To unfreeze the membership immediately, select the "Unfreeze" action.
</div>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
